import NavWidgetContainer from './NavWidgetContainer';
import NavWidgetControl from './NavWidgetControl';
import { Config } from './types';
import {
  defaultBackgroundData,
  defaultBackgroundImageData,
  defaultBorderData,
  defaultPaddingData,
  getDefaultNavMenuItems,
  getDefaultNavTreeOrder,
  widgetTypes,
} from 'builder/util/constants';

const initialMenuItems = getDefaultNavMenuItems();

export default {
  type: widgetTypes.Navigation,
  displayName: widgetTypes.Navigation,
  icon: 'bars',
  initialConfig: {
    height: 75,
    width: 450,
    xLocation: 10,
    yLocation: 10,
    minWidth: 70,
    minHeight: 70,
    ...defaultBackgroundData,
    ...defaultBackgroundImageData,
    ...defaultBorderData,
    ...defaultPaddingData,
    menuItems: initialMenuItems,
    uniqueId: '123abc',
    lineColor: 'black',
    parentId: '',
    iconColor: 'black',
    showDividerLines: true,
    showVerticalDivider: true,
    dividerLineColor: '#DADBDC',
    verticalDividerLineColor: '#DADBDC',
    font: 'OptumSans',
    fontSize: 16,
    textColor: 'black',
    sectionFont: 'OptumSans',
    sectionFontSize: 16,
    sectionTextColor: 'black',
    sectionBackgroundColor: 'white',
    // Maintains root-level tree order; nested items are managed within childOrder.
    treeOrder: getDefaultNavTreeOrder(initialMenuItems),
    treeData: undefined,
    style: 'Horizontal',
    enableFullScreen: false,
    allowedIdps: [],
    isDifferentTextColorOnHover: false,
    hoverTextColor: 'black',
    changeWidgetVisible: () => {},
    visible: true,
    currentMenuItem: 1,
    dropdownItemsBackgroundColor: 'transparent',
    bold: false,
    italic: false,
    underline: false,
    strikeThrough: false,
  },
  components: {
    render: NavWidgetContainer,
    control: NavWidgetControl,
  },
  copyable: true,
} as HorizonWidgetDefinition<Config>;
